var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavchandi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "201.000000pt",
    height: "176.000000pt",
    viewBox: "0 0 201.000000 176.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,176.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917 1413 c-3 -16 -24 -52 -46 -82 -61 -82 -53 -134 29 -176 30 -15 30 -15 30 13 0 15 11 43 25 62 50 67 51 136 3 187 -28 30 -34 29 -41 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 1268 c-13 -29 -30 -65 -37 -80 -19 -40 0 -43 41 -7 29 25 36 38 35 68 -1 71 -12 77 -39 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741 1062 c-47 -23 -70 -58 -77 -114 l-7 -48 273 0 273 0 -6 46 c-6 55 -31 93 -78 116 -28 15 -61 18 -189 18 -128 0 -161 -3 -189 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 835 c-63 -22 -105 -91 -93 -152 3 -17 23 -18 391 -21 l387 -2 0 38 c0 56 -29 103 -80 130 -43 21 -54 22 -305 22 -198 -1 -270 -4 -300 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 601 c-46 -20 -85 -84 -85 -142 l0 -29 520 0 520 0 0 30 c0 42 -22 90 -55 120 l-27 25 -426 2 c-235 1 -436 -2 -447 -6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavchandi);
export default __webpack_public_path__ + "static/media/navchandi.00b7fa277e0054313a14edceace9183f.svg";
export { ForwardRef as ReactComponent };